module.exports = __webpack_public_path__ + "img/quan.5f853626.png";